export enum UserEnableTransact {
  NO_ENABLE = '0',
  ENABLE_TEMPORAL = '1',
  ENABLE_FOREVER = '2',
  INACTIVE = '3',
}
